import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import WebRtcUtil from '../../../../old-crazy-web-frontend/src/app/utils/webrtc/webrtc.util';

@Injectable()
export class Ng1WebrtcUtilsService {
  public webRtcUtil: WebRtcUtil;

  constructor(private configService: ConfigService) {
    this.webRtcUtil = configService.getValue('WebRtcUtil');
  }
}
